import TwitterFollowButtonEditor from '@intercom/embercom-composer/components/twitter-follow-button-editor';
export default TwitterFollowButtonEditor;
